import React from "react";

const Java_Break = () => {
  return (
    <div>
      <h1>Java Break</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Break in Java.</p>
    </div>
  );
};

export default Java_Break;
